// extracted by mini-css-extract-plugin
export default {"selectedModels":"OnHoldAppOnTargets__selectedModels-TKH9R"};